import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { useHistory } from 'react-router-dom'

import {
  ModalBase,
  Botao,
  AutenticacaoContainer,
  formatarNome
} from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'
import { RotasAluno } from 'src/rotas/aluno'

import { ContainerAcoes, ContainerModal, CorpoModal } from './styles'
import { ModalLimiteCaracterRef, ModalLimiteCaracterProps } from './tipos'

const ModalLimiteCaracterCurso: React.ForwardRefRenderFunction<
  ModalLimiteCaracterRef,
  ModalLimiteCaracterProps
> = ({ backdrop, dataFinalizacao }, ref) => {
  const { usuario } = AutenticacaoContainer.useContainer()
  const [aberta, definirAberta] = useState(false)
  const [carregando] = useState(false)
  const history = useHistory()

  const nomeUsuario = usuario.nome.split(' ')[0]

  const fechar = () => {
    definirAberta(false)
  }

  const abrir = () => {
    definirAberta(true)
  }

  useImperativeHandle<ModalLimiteCaracterRef, ModalLimiteCaracterRef>(
    ref,
    () => ({
      fechar,
      abrir
    })
  )

  return (
    <ModalBase id="modal-pagamento" aberta={aberta} backdrop={backdrop}>
      <CorpoModal>
        <ContainerModal>
          <h5>Limite Atingido!</h5>
          <h3>
            Você atingiu o limite máximo de 500 caracteres para uma dúvida!
          </h3>

          <ContainerAcoes>
            <Botao
              texto="Fechar"
              tema="Secundario"
              type="button"
              disabled={carregando}
              onClick={() => fechar()}
            />
          </ContainerAcoes>
        </ContainerModal>
      </CorpoModal>
    </ModalBase>
  )
}

export const ModalLimiteCaracter = forwardRef(ModalLimiteCaracterCurso)
